var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { "show-on-mount": "", size: "large" },
      on: {
        hide: function($event) {
          return _vm.hide()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "modal-body" },
        [
          _c("touchpoint-overview", {
            attrs: {
              "brick-id": _vm.brickId,
              name: _vm.brickName,
              type: _vm.brickType,
              config: _vm.brickConfig,
              "disable-statistics": _vm.brickIsNew,
              "incoming-connections-info": _vm.IncomingConnectionsInfo,
              "outgoing-connections-info": _vm.OutgoingConnectionsInfo,
              "initial-tab": _vm.initialTab
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "modal-footer" }, [
        _c("div", { staticClass: "row justify-content-end" }, [
          _c("div", { staticClass: "col-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-lg",
                on: {
                  click: function($event) {
                    return _vm.hide()
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-check-circle" }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.resource("Button_OK")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }